/**
 * Shared form fields for organization-manager (role 5) create/edit.
 *
 * A manager belongs to an organization: on create the caller picks one of
 * the organizations it owns/manages (the option list is scoped by the
 * backend), and the backend maps the new user to it via user_organizations.
 * The organization membership is fixed after creation, so the selector is
 * shown on create only.
 */

import {
  TextInput,
  SelectInput,
  email,
  required,
  useGetList,
  useTranslate,
} from 'react-admin';

export const OrgManagerFormFields = ({ isCreate }: { isCreate: boolean }) => {
  const translate = useTranslate();
  const { data: organizations } = useGetList('organizations', {
    pagination: { page: 1, perPage: 500 },
    sort: { field: 'full_name', order: 'ASC' },
  });

  return (
    <>
      <TextInput source="full_name" validate={required()} />
      <TextInput source="email" type="email" validate={[required(), email()]} />
      {isCreate && (
        <TextInput
          source="password"
          type="password"
          validate={required()}
          autoComplete="new-password"
        />
      )}
      <TextInput source="contact_no" />
      {isCreate && (
        <SelectInput
          source="organization_id"
          validate={required()}
          choices={(organizations ?? []).map((org: any) => ({
            id: org.user_id,
            name: org.company_name || org.full_name,
          }))}
        />
      )}
      {!isCreate && (
        <SelectInput
          source="status"
          choices={[
            { id: 1, name: translate('common.status.active', { _: 'Activo' }) },
            { id: 0, name: translate('common.status.inactive', { _: 'Inactivo' }) },
          ]}
        />
      )}
    </>
  );
};

export default OrgManagerFormFields;
